import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BookingList.html?raw';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import TiBookingView from './BookingView';
import "./BookingView";
import "../TransportIntermodal/BookingForm";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import { TiEntities, TiInterfaces } from "./TiTypes";

const enum TiBookingType {
    "reserved" = 1,
    "booked" = 2
}
class TiBookingList extends compose(FinderBaseV2) {

    templateString: any = template;

    // must-have attach-points in der template !!!  KlassenProperties sind bereits in der FinderBase deklariert  ------------------------------ start
    //filterPanelContainer: HTMLDivElement;
    //sectionResult: HTMLDivElement;
    //btnSubmitLabel: HTMLElement;
    //btnSubmit: HTMLElement;
    //btnContinue: HTMLElement;
    //btnContinueLabel: HTMLElement;
    //resultMessageErrorContainer: HTMLElement;
    //resultMessageError: HTMLElement;
    //resultContainer: HTMLElement;
    // must-have attach-points in der template !!!  KlassenProperties sind bereits in der FinderBase deklariert   ------------------------------ end

    tableContainer: HTMLElement; // will be passed as a function parameter

    _isTableActive: boolean;
    buttonClickTimeout: number = null;
    _occurrenceEntityRequest: any = null;

    btnNewBooking: HTMLButtonElement;

    private _onClick_NewBooking(evt: MouseEvent) {
        location.href = window.appRoot + "TransportIntermodal/Bookingwizard";
    }
    private _formatTableCell(cell: StaticTable.StaticTableCell<TiEntities.BookingListEntity>) {

        let node = cell.contentnode;
        let entity: TiEntities.BookingListEntity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
           
            case "date_start":
            case "date_end":
                node.innerHTML = value;
                return true;
                break;
            case "route":
                if (entity.ref_vt_timeslot) {
                    value = entity.ref_vt_timeslot.ref_main_route.name;
                }
                node.innerHTML = value;
                return true;
                break;
            case "order_number":
                
                if (!value) {
                    value = "-";
                } else {
                    
                }
                node.innerHTML = value;
                return true;
                break;
            case "status":
                let status = this.translations["TiBooking__StatusBooked"];
                if (entity.is_contains_canceld_section_timeslot == true && entity.is_canceld_section_timeslot_corrected != true) {
                    this.UiModder.domClass.add(cell.tableRow.node, "timeslotWarning");
                }
                if (entity.is_cancelled) {
                    this.UiModder.domClass.add(cell.tableRow.node, "cancelled");
                    //status = this.translations["TiBooking__StatusCancelled"];
                } //else if (entity.booking_entity_resource_type == TiBookingType.booked) {
                //    if (entity.is_rebook) {
                //        status = this.translations["TiBooking__StatusRebooked"];

                //    }
                //} else if (entity.booking_entity_resource_type == TiBookingType.reserved) {
                //    status = this.translations["TiBooking__StatusReserved"];
                //}

                
                this.UiModder.domAttr.set(node, "innerHTML", value);

                //let random = Math.random();
                //if (entity.is_contains_reserved_section_timeslot == true && entity.is_cancelled != true) {
                //    //let container = this.UiModder.domConstruct.create("div", { "className": "w3-section"}, node);
                //    let confirmRebookingBtn = this.UiModder.domConstruct.create("BUTTON", {
                //        "class": "mds-button-base round cD1 hoverBright",
                //        "onclick": lang.hitch(this, this._onClick_ConfirmReservedSectionSlots, entity, cell.tableRow.node),
                //        "innerHTML": this.translations["TiBooking__BtnConfirmReservedSectionSlots"]
                //    }, node, "only");
                //    let icon = this.createFontawesomeIcon("fa-regular fa-calendar-check", "&nbsp;");
                //    this.UiModder.domConstruct.place(icon, confirmRebookingBtn, "first");
                //}


                return true;
                break;
            case "details":
            case "actions":
                // hier button einbauen
                let btn = this.UiModder.domConstruct.create("BUTTON", {
                    "class": "mds-button-base round tertiaryBG mds-hover-bright",
                    "onclick": lang.hitch(this, this._onDetailsButton_click, entity, cell.tableRow.node)
                }, node);
                this.UiModder.domConstruct.create("I", { "class": "fa-solid fa-search-plus" }, btn, "first");


                //// STORNO
                //btn = this.UiModder.domConstruct.create("BUTTON", {
                //    "class": "mds-button-base round w3-red mds-hover-bright w3-margin-right",
                //    "onclick": lang.hitch(this, this._onCancelButton_click, entity.ID, cell.tableRow.node),
                //    "innerHTML": "Storno"
                //}, node, "first");

                //// BUCHEN-Button wenn Orderno noch leer
                //if (!entity.order_number) {
                //    let btn = this.UiModder.domConstruct.create("BUTTON", {
                //        "class": "mds-button-base round accentBG mds-hover-bright w3-margin-right",
                //        "onclick": lang.hitch(this, this._onBookButton_click, entity.ID, cell.tableRow.node),
                //        "innerHTML": "Buchen"
                //    }, node, "first");
                //    //this.UiModder.domConstruct.create("I", { "class": "fas fa-search-plus" }, btn, "first");
                //}
                return true;
                break;

            default:
                if (value == null || value == "" || typeof value == "undefined") {
                    value = "N.A.";
                    node.innerHTML = value;
                    return true;
                }
                break;
        }

        return false;
    }

    private _onDetailsButton_click(entity: TiEntities.BookingListEntity, node: HTMLElement, evt: MouseEvent): void {
        // triggert folgende Ereigniskette: zuerst die entity laden , dann die details in die OccurrenceForm laden,
        //wenn iditierung nicht erlaub ist - readOnly setzen
        //console.debug("_onDetailsButton_click", );
        this.StandbyStart(node);

        let bookingView = new TiBookingView();
        bookingView.setup(entity.ID, {
            showBookingFormConfirmation: true,
            showMainRoute: true,
            showSummary: "noExpander",
            showTransportRoute: true,
            mainRouteViewConfig: {
                sectionsConfig: {
                    enableBookingStatus: this.hasUserRole("TI_RouteSlotsReview") ? "interactive" : true,
                    showExtendedInformation: true
                }
            }
        });

        bookingView.on("change", lang.hitch(this, this._onBookingUpdated));
        bookingView.on("loaded", lang.hitch(this, this.StandbyStop));

        if (evt) {
            evt.stopPropagation();
        }
    }

    

    private _onBookingUpdated(bookingID: string) {
       
        this.reload();
    }


    //private showBookingInput(bookingID: string) {
    //    let dlg = new GenericDialog;
    //    dlg._setHeaderAttr("Buchung bestätigen");

    //    let input = <HTMLInputElement>this.UiModder.domConstruct.create("input", {
    //        "type": "text",
    //        "className": "w3-padding-small accentOutline w3-block",
    //        "placeholder": this.translations["TiBooking__OrderNo"]
    //    });

    //    dlg.addNodeToContent(input);
    //    dlg._setOkBtnAttr(true);
    //    dlg._setCancelBtnAttr(true);
    //    dlg.setCloseOnEnter(false);
    //    dlg.setCloseOnEscape(true);

    //    dlg._setCallbackAttr(lang.hitch(this, this._onBookingInputResponse, bookingID, input.value))

    //    dlg.show();

    //}

    private _onBookingInputResponse(bookingID: string, orderNo: string, result: number) {
        if (result < 1) {
            return;
        }

        if (!orderNo) {
            alert("missing order number");
            return;
        }

        this.confirmBooking(bookingID, orderNo);

    }


    private confirmBooking(bookingID: string, orderNo: string) {
        let url = window.appRoot + "TransportIntermodal/ConfirmBooking";

        let data = { "bookingID": bookingID, "orderNo": orderNo };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onConfirmBookingResponse),
            lang.hitch(this, this._onConfirmBookingError),
            false // sync
        );
    }

    private _onConfirmBookingResponse(response) {

    }

    private _onConfirmBookingError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }


    private _onLoadItemSummaryError(error: more.requestErrorMessage) {
        this.StandbyStop();
    }



    private _onClick_Cell(cell: StaticTable.StaticTableCell<any>, rowGroup: StaticTable.StaticTableRowGroup<TiEntities.BookingListEntity>, evt: MouseEvent) {
        //console.debug("_onClick_Cell", cell, cell.entity, evt);
    }

    private _onClick_Row(rowLine: StaticTable.StaticTableRow<any>, rowGroup: StaticTable.StaticTableRowGroup<TiEntities.BookingListEntity>, evt: MouseEvent) {
        //console.debug("_onClick_Row", rowLine, rowGroup.entity, evt);
        this._onDetailsButton_click(rowGroup.entity, rowLine.node, evt);

        if (evt) {
            evt.stopPropagation();
        }
    }

    // Event handlers--------------------------------------------------END
    // overrides -----------------------------------------------start
    filterOptions_additionalConfig(): void { //Base
        //// specify options configuration here.
        //// Exmaples:
        //// var option = this.findOptionByName("displayDate");
        //// if (option) option.set("readonly", true);
        //// var option = this.findOptionByName("highlightItems");
        //// if (option) option.set("highlightItems", true);

        setTimeout(lang.hitch(this, this.setPage, 1, true), 350);

    }

    // change Evens der Filterpanel fangen
    _onOptionValueChange(dataObj: filterPanel_option_valuechange_obj): void { //Base
        // pass
    }

    private firstLoadDone: boolean = false;
    private _firstLoad() {
        if (!this.firstLoadDone) {
            this.firstLoadDone = true;
            this.getFilterlist(1);
        }
    }
    private _onEntitySaved() {
        this.getFilterlist(1);
    }

    // --------------------own methods ----------------------------end

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.onDirtyChange = lang.hitch(this, this._firstLoad);

        this.setupFinder(
            "TransportIntermodal/GetFilterpanelOptions",
            "TransportIntermodal/LoadBookingList",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this._formatTableCell),
            {
                neededUserRole: "TI_wizard",
                callback: lang.hitch(this, this._onClick_NewBooking)
            }
        );

        this.useStandbyManager = true;

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles(this.translations["TiBookingList__MainTitle"], null);

    }
}

export default mdsWidget(TiBookingList);
